import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { empty } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-catalogs-catalog-centers-card',
  templateUrl: './catalogs-catalog-centers-card.component.html',
  styleUrls: ['./catalogs-catalog-centers-card.component.scss']
})
export class CatalogsCatalogCentersCardComponent implements OnInit, OnDestroy {

  @Input() catalog: CatalogBasic;
  centers;
  selectedCenters;
  updateCatalogCentersSubscription: Subscription;

  constructor(private catalogsService: CatalogsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.centers = this.userStorageService.getCenterList();
  }

  public duallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
      this.updateCatalogCenters(this.getCentersInternalids(this.selectedCenters));
    }
  }

  public updateCatalogCenters(centersInternalIds) {
    this.updateCatalogCentersSubscription = this.catalogsService.updateCatalogCenters(this.catalog.InternalId, centersInternalIds).pipe(
      tap(o => this.catalogsService.refreshCatalog()),
      tap(o => this.snackbarService.open('catalogs-page.snackbar messages.update catalog success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getCentersInternalids(centers) {
    if (centers) {
      return centers.map(c => c.InternalId);
    }
    return [];
  }
  ngOnDestroy() {
    if (this.updateCatalogCentersSubscription) { this.updateCatalogCentersSubscription.unsubscribe(); }
  }

}
